import { Form as FormikForm } from 'formik';
import Header from 'components/Profile/Header';
import StepFooter from 'components/Profile/StepFooter';
import { getStepById } from 'pages/Profile/helper';

const StepShell = ({ stepId, isSubmitting = false, bodyClassName = '', inModal = false, formId = '', children }) => {
  const step = getStepById(stepId);

  return (
    <FormikForm noValidate id={formId || `${stepId}-form`} className="flex min-h-0 flex-1 flex-col">
      <div className={`min-h-0 flex-1 ${inModal ? '' : 'overflow-y-auto px-5 pb-7 pt-5 lg:px-10'}`}>
        {step && (
          <div className="mb-5">
            <Header
              icon={step.icon}
              iconBg={step.iconBg}
              iconColor={step.iconColor}
              title={step.title}
              description={step.subtitle}
            />
          </div>
        )}
        <div className={`animate-slide-up ${bodyClassName}`}>{children}</div>
      </div>

      {!inModal && <StepFooter stepId={stepId} isSubmitting={isSubmitting} />}
    </FormikForm>
  );
};

export default StepShell;
